var MARCHBURNNYC = {
    
    init: function() {

        document.body.addEventListener('submit',(e) => {
            
            if(!e.target.dataset.marchburnBindForm)
                return true;

             e.preventDefault();

            if(e.target.dataset.marchburnBindForm == 'addtocart.grid')
                this.addToCart(e.target);
            
            return false;
        
        });

    },

    addToCart: async function ( formEl ) {

        let formData = new FormData(formEl);
        let res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: new FormData(formEl)
        });
        let data = await res.json();
        
        var submitButtonEl = formEl.querySelector('input[type="submit"]');
        if(submitButtonEl) {
            submitButtonEl.type = 'button';
            submitButtonEl.value = 'ADDED';
            submitButtonEl.style.backgroundColor = '#000';
            submitButtonEl.style.border = '2px solid #226fc9';
            submitButtonEl.style.color = '#ffffff';
            submitButtonEl.style.padding = '10px 10px';
            submitButtonEl.insertAdjacentHTML('afterend','<a style="display:block; text-decoration: underline; margin-top: 10px" href="/cart">view cart</a>');
        }

        theme.sections.register('header', theme.HeaderSection);
        
    }


}

// Init.
document.addEventListener("DOMContentLoaded", function(event) {
    MARCHBURNNYC.init();
});